import React, {Component} from 'react'
import { connect } from 'react-redux'
import { currencyToText, displayOddsType } from 'utils/converters'
import { bookmakers } from 'config'
import MatchCell from '../MatchCell'
import StartCell from '../StartCell'

class EdgebetRow extends Component {
  constructor(props) {
    super(props)
    this.onClick = this.onClick.bind(this)
  }

  onClick() {
    this.props.onClick(this.props.edgeKey)
  }

  render() {
    let selected = this.props.selected ? ' selected' : '';
    let toolTipClassName = ''
    let toolTipText = ''
    if (!!this.props.userbet) {
      let oddsTypeText = displayOddsType(this.props.userbet.oddsType, this.props.userbet.output, this.props.userbet.oddsTypeCondition)
      let amountText = currencyToText(this.props.userbet.wager, this.props.userbet.currency)
      toolTipText = 'You have placed ' + amountText + ' on ' + oddsTypeText + ' @ ' + this.props.userbet.odds + ' on ' + this.props.userbet.bookmaker.name
      toolTipClassName = ' placed'
    }
    return (
      <tr onClick={this.onClick} className={'edge-row' + selected + toolTipClassName} data-tip={toolTipText} data-for='edgebets'>
        <MatchCell homeTeam={this.props.homeTeam} awayTeam={this.props.awayTeam} userbet={this.props.userbet}/>
        <StartCell startTime={ this.props.startTime } />
        <td className="bookmaker-cell">{ bookmakers[this.props.bookmaker] }</td>
        <td className='oddstype-cell lg-up-only'>{ displayOddsType(this.props.oddsType, this.props.output, this.props.oddsTypeCondition) }</td>
        <td className='odds-cell lg-up-only'>{ this.props.odds }</td>
        <td className="betsize-cell">{ currencyToText(Math.round(this.props.kelly * this.props.totalBankroll * this.props.kellyFrac), this.props.user.currency) }</td>
        <td>{ this.props.edge }%</td>
        { !!this.props.userbet }
      </tr>
    )
  }
}

export default connect()(EdgebetRow)



/** WEBPACK FOOTER **
 ** ./src/components/edgebets/EdgebetRow.js
 **/